module.exports = __webpack_public_path__ + "img/logo.cfbcf6ab.png";